"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
const danger = '#d70b0b';
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'connect',
    userFriendlyName: 'Connect',
    colors: {
        primary: '#292c3e',
        primaryText: '#fff',
        primaryDark: '#112',
        danger,
        muted: '#ccc',
        success: '#87c144',
        offline: danger,
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        online: '#87c144',
        accent: '#09d3ac',
        accentBackgroundedText: '#FFF',
        pageBackground: '#f5f6fb',
        cardBackground: '#fff',
        cardText: '#000',
        charts: {
            primary: '#4abfff',
            min: '#a1e0f8',
            neutral: '#999',
            max: '#f7b2bb',
            intervalShade: '#ddd',
        },
    },
});
//# sourceMappingURL=index.js.map